import SplashCats from '../../assets/images/login-v2/splash_cats.png';

export default function AuthMascot({ size = 'md', className = '' }) {
  const sizeClass = size === 'lg' ? 'h-[95px] w-[172px]' : 'h-[55px] w-[100px]';

  return (
    <img
      src={SplashCats}
      alt=""
      role="presentation"
      className={`${sizeClass} object-contain ${className}`}
    />
  );
}
